<template>
  <div class="home">
    <headerWhite-view></headerWhite-view>
    <!-- 轮播 -->
    <div class="swiper_wrap">
      <div class="swiper_left flex-align-around" style="left:50px" @click="prev">
        <img src="@/assets/img/footer/left.png" />
      </div>
      <el-carousel class="swiper" height="700px" arrow="never" ref='carousel'>
        <el-carousel-item v-for="(item,index) in bannerList" :key="index" class="item">
          <img :src="item.image" @click="clickBanner(item.url)">
        </el-carousel-item>
      </el-carousel>
      <div class="swiper_right flex-align-around" style="right:50px" @click="next">
        <img src="@/assets/img/footer/right.png" />
      </div>
    </div>
    <div class="word_info">
      <div class="video_wrap flex-column-between">
        <div class="video">
          <video src="@/assets/address.mp4" controls="controls">您的浏览器不支持 video 标签。</video>
        </div>
        <div class="video_title flex-align-between">
          <img src="@/assets/home/video_title.png" />
          <div style="width:6px;height:100%;background:#1C4B90;margin-right:3px"></div>
        </div>
      </div>
    </div>
    <div class="pattern">
      <div class="pattern_content flex-column">
        <div class="title">“首都带首府”京银教育合作“互联网+教育”模式</div>
        <div class="title2">北京市教委、银川市政府加强共享优质教育资源，打造可复制、可推广的教育品牌工程</div>
        <div class="pattern_wrap flex-align-around">
          <div class="pattern_item flex-column">
            <img src="@/assets/home/resource.png" />
            <div class="name">优质资源输出</div>
            <div class="content">旨在对口地区从教育层面将北京的优质资源精准引入对口地区</div>
          </div>
          <div class="pattern_item flex-column">
            <img src="@/assets/home/internet.png" />
            <div class="name">互联网+</div>
            <div class="content">借助“互联网+”搭建对应平台对引入资源的对口地区，提供教育精准帮扶</div>
          </div>
          <div class="pattern_item flex-column">
            <img src="@/assets/home/brand.png" />
            <div class="name">品牌工程</div>
            <div class="content">首都教育远程互助工程旨在对口地区从教育资源上精准帮扶和交流，从而在教育方法树立的品牌工程</div>
          </div>
        </div>
        <div class="detail csp" @click="showDetail(1)">了解详情</div>
      </div>
    </div>
    <div class="main">
      <div class="main_content">
        <img src="@/assets/home/refuel.png" />
        <div class="main_name flex-align-around">
          <img src="@/assets/home/university.png" />
        </div>
        <div class="main_detail">
          <div class="detail_text">
            “首都师范大学”双优项目是集合首师大的优质资源项目形成的以“社会服务”为核心，搭载“首都教育
            远程互助工程”向全国地区推送首都师范大学的“社会服务”类研修项目。发挥首师大在教育教学研究层面的优势
            集中力量协助帮扶地区就教师能力体系提升提供全方面的解决方案。
          </div>
          <div class="detail_btn csp" @click="showDetail(2)">
            了解详情
          </div>
        </div>
      </div>
    </div>
    <footer-view></footer-view>
  </div>
</template>
<script>
  import {
    mapState,
    mapMutations
  } from "vuex";
  export default {
    name: "home",
    data() {
      return {
        name: "双优云桥",
        active: 0,
        menu_list: [
          "首页",
          "新闻咨询",
          "云桥概况",
          // "名师风采",
          "专题网站",
          "关于我们"
        ],
        bannerList: []
      };
    },
    computed: mapState({
      teaPlanTerm: state => state.login.teaPlanTerm
    }),
    components: {},
    methods: {
      ...mapMutations({
        PlanTerm: "teaPlanTerm" // 将 `this.PlanTerm()` 映射为 `this.$store.commit('increment')`
      }),
      clickBanner(url) {
        window.open(url)
      },
      go_menu(index) {
        this.active = index;
      },
      prev() {
        console.log('上一张')
        this.$refs.carousel.prev()
      },
      next() {
        console.log('下一张')
        this.$refs.carousel.next()
      },
      async getBanner() {
        let resData = await Api.Home.getBanner()
        this.bannerList = resData.data
      },
      showDetail(type) {
        if (type == 1) {
          sessionStorage.setItem('active', 2)
          this.$router.push('/yunqiao')
        } else if (type == 2) {
          sessionStorage.setItem('active', 2)
          this.$router.push('/yunqiao/detail_syyq')
        }
      }
    },
    mounted() {
      this.PlanTerm("成功");
      // console.log(this.teaPlanTerm);
      this.getBanner()
    },
    created() {}
  };
</script>

<style lang="less">
  @import "./less/home.less";
</style>